<template>
	<div class="card">
		<header class="card-header">
			<ul class="tab-head-list">
				<li
					:class="['tab-head', {'active-tab-head': activeTab === tab }]"
					v-for="(tab, index) in tabs"
					:key="index"
					@click="switchTab(tab);"
				>
					<span class="tab-label">
						<slot name="tab-label" v-bind="tab"></slot>
					</span>
				</li>
			</ul>
			<slot name="tab-header"></slot>
		</header>
		<main class="card-body">
			<slot name="tab-body" v-bind="activeTab"></slot>
		</main>
  </div>
</template>

<script>
export default {
	name: 'TabCard',
	props: {
		initialTab: {
			required: false,
		},
		tabs: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			activeTab: this.initialTab,
		};
	},
	methods: {
		switchTab(tab) {
			if (tab !== this.activeTab) {
				this.activeTab = tab;
				this.$store.dispatch("sound/fx/play", { id: "change_tab" });
			}
		},
	},
	mounted() {
		this.activeTab = this.initialTab ? this.initialTab : this.tabs[0];
	},
};
</script>

<style lang="scss" scoped>
.card {
	width: 90%;
	height: 50%;

	@include desktop {
		width: 1000px;
		height: 40%;
	}

	@include desktop-sm {
		height: 50%;
	}
}

.card-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	color: $body-txt-color;
}

.tab-head-list {
	display: flex;
	font-family: $headline-font;
	font-size: $font-size-sm;
	text-transform: uppercase;
	padding-left: 2em;

	@include mobile { font-size: $font-size-xx-sm; }
}

.tab-head {
	cursor: pointer;
	position: relative;
	background: $alt-color;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 2em;
	padding: .25em 1.5em 0;

	&::before,
	&::after {
		content: '';
		position: absolute;
		display: inline-block;
		border-color: $alt-color;
		width: 0;
		height: 0;
		top: 0;
	}

	&::before {
		border-bottom: 2em solid $alt-color;
		border-left: 2em solid transparent;
		left: -2em;
	}

	&::after {
		border-bottom: 2em solid $alt-color;
		border-right: 2em solid transparent;
		right: -2em;
	}

	&:nth-child(2) {
		background: $alt-color-dark;
		z-index: $z-mid;

		&::before { border-bottom: 2em solid $alt-color-dark; }
		&::after { border-bottom: 2em solid $alt-color-dark; }
	}

	&.active-tab-head {
		background: $off-white-dark;
		transition: $ui-transition-duration;
		z-index: $z-top;

		&::before,
		&::after {
			border-bottom-color: $off-white-dark;
			transition: $ui-transition-duration;
		}
	}
}

.card-body {
	background: $off-white-dark;
	height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/base/TabCard.vue